'use client'

import { ColumnDef } from '@tanstack/react-table'
import { KPIPayoutTableModel } from '@/types/targets'

import {
  DataTableColumnCell,
  DataTableColumnHeader,
  Format,
} from '@/components/ui/data-table'

import ScalrBadge from '@/components/ScalrBadge'

export const kpiPayoutTableColumns: ColumnDef<KPIPayoutTableModel>[] = [
  {
    accessorKey: 'kpiId',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'KPI ID',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'kpiId',
      })
    },
    enableSorting: true,
  },
  {
    accessorKey: 'area',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'AREA',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'area',
      })
    },
    enableSorting: true,
  },
  {
    accessorKey: 'kpiName',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'KPI NAME',
      })
    },
    cell: ({ row }) => {
      return ScalrBadge({
        row,
        accessorKey: 'kpiName',
      })
    },
    enableSorting: true,
  },
  {
    accessorKey: 'description',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'DESCRIPTION',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'description',
      })
    },
    enableSorting: true,
  },
  {
    accessorKey: 'calculation',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'CALCULATION',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'calculation',
      })
    },
    enableSorting: true,
  },
  {
    accessorKey: 'target',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'TARGET',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'target',
        format: Format.PERCENT,
      })
    },
    enableSorting: true,
  },
  {
    accessorKey: 'achievement',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'ACHIEVEMENT',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'achievement',
        format: Format.PERCENT,
      })
    },
    enableSorting: true,
  },
  {
    accessorKey: 'bonus',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'BONUS',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'bonus',
        format: Format.PERCENT,
      })
    },
    enableSorting: true,
  },
  {
    accessorKey: 'result',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'RESULT',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'result',
        format: Format.PERCENT,
      })
    },
    enableSorting: true,
  },
  // {
  //   accessorKey: 'payout',
  //   header: ({ column }) => {
  //     return DataTableColumnHeader({
  //       column,
  //       title: 'PAYOUT',
  //     })
  //   },
  //   cell: ({ row }) => {
  //     return DataTableColumnCell({
  //       row,
  //       accessorKey: 'payout',
  //       format: Format.PERCENT,
  //     })
  //   },
  //   enableSorting: true,
  // },
]
